import React, { useState } from 'react';
import { FiPlus, FiList } from 'react-icons/fi';
import BankSidebar from '../components/BankSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function BankTransactions() {
  const [data, setData] = useLocalState('bank_trans_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });

  const handleAdd = (newData) => { setData([newData, ...data]); };
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <BankSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1 text-gray-800">
          <div className="flex items-center space-x-2">
            <FiList className="text-xl opacity-70 text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Bank Transactions ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded shadow-sm hover:bg-blue-900 transition-colors">
            <FiPlus className="text-sm" />
          </button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black shadow-sm">
          <table className="min-w-full border-collapse text-[12px] text-gray-800">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900 select-none">
                <th onClick={() => handleSort('ref')} className="font-normal p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('date')} className="font-normal p-2 border border-black text-left cursor-pointer">Date</th>
                <th onClick={() => handleSort('desc')} className="font-normal p-2 border border-black text-left cursor-pointer">Description</th>
                <th onClick={() => handleSort('account')} className="font-normal p-2 border border-black text-left cursor-pointer">Account</th>
                <th onClick={() => handleSort('type')} className="font-normal p-2 border border-black text-left cursor-pointer">Type</th>
                <th onClick={() => handleSort('amount')} className="font-normal p-2 border border-black text-right cursor-pointer">Amount</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black">{row.ref}</td>
                  <td className="p-2 border border-black">{row.date}</td>
                  <td className="p-2 border border-black">{row.desc}</td>
                  <td className="p-2 border border-black">{row.account}</td>
                  <td className="p-2 border border-black font-bold text-[11px]"><span className={row.type === 'Credit' ? 'text-green-600' : 'text-red-600'}>{row.type}</span></td>
                  <td className="p-2 border border-black text-right">{row.amount}</td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="6" className="p-4 text-center text-gray-500">No records found</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Transaction" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'date', label: 'Date' }, { name: 'desc', label: 'Description' },
          { name: 'account', label: 'Bank Account' }, { name: 'type', label: 'Type (Credit/Debit)' }, { name: 'amount', label: 'Amount' }
        ]} />
      </div>
    </div>
  );
}